import EntityCRUD, { iBaseEntity } from "./EntityCRUD";

export interface iCity extends iBaseEntity {
  id: string;
  name: string;
  stateId: number;
}

export type iCityModel = Omit<iCity, "stateId"> & {
  state_id: number;
};

export default class City extends EntityCRUD<iCity> {
  static basePath = "/cities";

  static adapter(data: iCity | iCityModel) {
    if ((data as iCityModel).state_id !== undefined) {
      const model = data as iCityModel;
      return {
        ...model,
        stateId: model.state_id,
      };
    } else {
      const item = data as iCity;
      return {
        ...item,
        state_id: item.stateId,
      };
    }
  }

  static create(data: iCity) {
    return EntityCRUD.createBase<iCity>(data);
  }
}
